import { render, staticRenderFns } from "./TaskDetailAssignmentCard.vue?vue&type=template&id=f35252f2"
import script from "./TaskDetailAssignmentCard.vue?vue&type=script&lang=js"
export * from "./TaskDetailAssignmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports